export default "__VITE_ASSET__8dc35a69__"